module.exports = __webpack_public_path__ + "img/wifi_signal_1_selected.13d8edd7.svg";